import { Link } from "react-router-dom";
import { newsList, fmtDate } from "@/mocks/anime";

export default function NewsPreview() {
  const featured = newsList[0];
  const rest = newsList.slice(1, 4);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100" aria-labelledby="news-preview-title">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <p className="text-[11px] font-bold tracking-[0.2em] text-accent-600 mb-2">INSIGHT</p>
          <h2 id="news-preview-title" className="text-xl md:text-2xl font-black text-foreground-950 tracking-tight">
            最新动漫资讯精选
          </h2>
          <p className="mt-2 text-[13px] text-foreground-600">作品动态、档期情报与行业观察</p>
        </div>
        <Link
          to="/news"
          className="inline-flex items-center gap-1 text-[13px] font-medium text-primary-700 hover:text-primary-800 transition-colors whitespace-nowrap cursor-pointer"
        >
          全部资讯 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
        <Link
          to={`/news/detail/${featured.id}`}
          className="group bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
        >
          <div className="w-full aspect-[16/9] overflow-hidden bg-background-200">
            <img
              src={featured.cover}
              alt={`${featured.title}资讯配图`}
              title={`${featured.title} - 妖精动漫资讯`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
            />
          </div>
          <div className="p-4 md:p-5">
            <div className="flex items-center gap-2 text-[11px] text-foreground-500">
              <span className="px-2 py-0.5 rounded bg-accent-100 text-accent-900 font-semibold">{featured.category}</span>
              <span>{fmtDate(featured.date)}</span>
            </div>
            <h3 className="mt-3 text-[16px] md:text-[18px] font-bold text-foreground-950 leading-7 group-hover:text-primary-700 transition-colors">
              {featured.title}
            </h3>
            <p className="mt-2 text-[13px] text-foreground-600 leading-6 line-clamp-2">{featured.summary}</p>
          </div>
        </Link>

        <div className="flex flex-col gap-3 md:gap-4">
          {rest.map((news) => (
            <Link
              key={news.id}
              to={`/news/detail/${news.id}`}
              className="group flex flex-col sm:flex-row gap-3 p-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="w-full sm:w-[140px] h-[140px] sm:h-[104px] rounded-md overflow-hidden shrink-0 bg-background-200">
                <img
                  src={news.cover}
                  alt={`${news.title}资讯缩略图`}
                  title={`${news.title} - 妖精动漫资讯`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-center">
                <div className="flex items-center gap-2 text-[11px] text-foreground-500">
                  <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 font-semibold">{news.category}</span>
                  <span>{fmtDate(news.date)}</span>
                </div>
                <h3 className="mt-2 text-[14px] font-semibold text-foreground-950 leading-6 line-clamp-2 group-hover:text-primary-700 transition-colors">
                  {news.title}
                </h3>
                <p className="mt-1.5 text-[12px] text-foreground-500 line-clamp-1">{news.summary}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}